import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';

import { BaasicButton } from 'core/components';

const BaasicFormControlsTemplate = function (props) {
    const { form, onSubmit, controls, t, disabled, label, className, authorized = true } = props;

    return (
        <React.Fragment>
            {(!controls || controls.onSubmit) && (
                <BaasicButton
                    type='submit'
                    className= {className ? className : "btn btn--base btn--primary"}
                    onClick={onSubmit || form.onSubmit}
                    disabled={disabled || form.submitting || form.validating}
                    rotate
                    icon={
                        form.submitting || form.validating
                            ? "u-icon u-icon--sml u-icon--sync u-rotate--login u-mar--right--tny"
                            : 'u-display--none'
                    }
                    label={label ? label : t('FORM_CONTROLS.SAVE_BUTTON')}
                    authorized={authorized}
                />
            )}

            {/* TODO: add more form controls here if required */}
        </React.Fragment>
    );
};

BaasicFormControlsTemplate.propTypes = {
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    disableSave: PropTypes.bool,
    controls: PropTypes.object,
    validation: PropTypes.object,
    authorization: PropTypes.any,
    t: PropTypes.any,
    disabled: PropTypes.bool,
    label: PropTypes.any,
    className: PropTypes.any,
    authorized: PropTypes.any
};

BaasicFormControlsTemplate.defaultProps = {
    validation: {}
};

export default defaultTemplate(BaasicFormControlsTemplate);
